"use strict";const i=require("styled-components").css`
    display: grid;
    grid-row-gap: 12px;
    margin-top: 40px;
    padding: 40px;
    background: ${({theme:i})=>i.colors.common.light};
    border-radius: ${({theme:i})=>i.borderRadiuses.medium};
    box-shadow: ${({theme:i})=>i.shadows.low};

    @media (min-width: ${({theme:i})=>i.breakpoints.medium}) {
        grid-template-columns: ${({iconOverlay:i})=>!i&&"160px auto"};
        grid-column-gap: 46px;
        align-items: center;
        margin: 0;
    }

    .DXIconCard-icon {
        width: 160px;
        height: 160px;
        margin: -80px auto 0;

        > * {
            width: 100%;
            height: 100%;
        }

        @media (min-width: ${({theme:i})=>i.breakpoints.medium}) {
            margin: auto;
            ${({iconOverlay:i})=>i&&"\n                position: absolute;\n                top: -15px;\n                right: -85px\n            "}
        }
    }

    .DXIconCard-content {
        .DXChip {
            margin: 0;
        }
        .DXIconCard-heading {
            margin: 0px 0px 12px;
        }
    }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
